/* tslint:disable */
/* eslint-disable */
/**
 * Public Reply Service
 * Service submit public and query contact information of public replies
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * Submission status of avalanche report
 * @export
 * @enum {string}
 */

export const AvalancheReportStatus = {
    Success: 'SUCCESS',
    PartialSuccessDocumentFail: 'PARTIAL_SUCCESS_DOCUMENT_FAIL'
} as const;

export type AvalancheReportStatus = typeof AvalancheReportStatus[keyof typeof AvalancheReportStatus];



